import "babel-polyfill";

import Vue from 'vue'

// element-ui 组件库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入初始化样式
import '@/assets/css/base/base.css';
import '@/assets/css/base/main.css';

import App from './App.vue'
import store from './store/store'
import router from './router/index';

//引入mock 模拟数据
import Mock from '@/mocks'
import config from '@/config'

if(config.MOCK){
  Mock.bootstrap()
}

// //引入请求拦截器
import axios from './resources/interceptors/httpServer'
Vue.prototype.$ajax = axios;

//引入js全局方法
import base from '@/common/base';
//引入全局过滤器
// import filters from '@/common/filters'
// 引入cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import JSEncrypt  from 'jsencrypt'
JSEncrypt.default_key_size=1024

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  size: 'small'
})
Vue.use(base);

store.commit('menu/loadMenus');
router.addRoutes(store.getters.getRoutes)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
